import { render, staticRenderFns } from "./KanbanNew.vue?vue&type=template&id=324491de&scoped=true&"
import script from "./KanbanNew.vue?vue&type=script&lang=js&"
export * from "./KanbanNew.vue?vue&type=script&lang=js&"
import style0 from "./KanbanNew.vue?vue&type=style&index=0&id=324491de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324491de",
  null
  
)

export default component.exports